























































































































































































































































































































































































































declare var window: any;
import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator';
import ConfirmationModal from '@/components/Commons/ConfirmationModal.vue';
import { vxm } from '../../store.vuex';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import Paginate from 'vuejs-paginate';
Vue.component('paginate', Paginate);
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import Loader from '../Loader.vue';
import GuidedSignupUtilities from '@/components/GuidedSignup/utilities';
import SkillCard from '@/components/Commons/SkillCard.vue';
import { UserLicence } from '@/models/userlicence/UserLicence';
import { LicenceDocument } from '@/models/licence/LicenceDocument';
import { DocumentResponse } from '@/models/skills/documentresponse';
import { UserAttribute } from '@/models/jobs/userattribute';
import { SkillResponse } from '@/models/skills/skillresponse';
import { LicenceMasterData } from '@/models/licence/LicenceMasterData';
import { VerticalSkillRespose } from '@/models/skills/VerticalSkillRespose';
import { LicenceUploadInfo } from '@/models/licence/LicenceUploadInfo';
import { LicenceUploadPayload } from '@/models/licence/LicenceUploadPayload';
import { DocumentPayload } from '@/models/skills/documentpayload';
import { LicenceMasterDataList } from '@/models/licence/LicenceMasterDataList';
import Paginator from '@/components/Commons/Paginator.vue';

@Component({
  name: 'SelectedLicenceList',
  components: {
    Datepicker,
    Loader,
    SkillCard,
    SelectedLicenceList,
    Paginator,
  },
})
export default class SelectedLicenceList extends Vue {
  $refs: any;
  $moment: any;
  $wlToastr: any;

  private companyLicenceWrapper: LicenceMasterDataList = new LicenceMasterDataList();
  private documentPayload: DocumentPayload = new DocumentPayload();
  private saveLicencePayload: LicenceUploadPayload = new LicenceUploadPayload();
  private licenceUploadInfo: LicenceUploadInfo = new LicenceUploadInfo();
  private licenceDocument: LicenceDocument = new LicenceDocument();
  private componentKey: number = 0;
  private currentPage: number = 1;
  private recsPerPage: number = 5;
  private currentPageTop: number = 1;
  private recsPerPageTop: number = 5;
  private selectedIndex: number = -1;
  private selectedSkillId: number = -1;
  private bFormFiles: any[] = [];
  private editLicence: boolean = false;
  private expandAll: boolean = false;
  private searchSkill: string = '';
  private filteredCompanySkills: SkillResponse[] = [];
  private companyVerticalSkills: VerticalSkillRespose[] = [];
  private filteredCompanyVerticalLicence: LicenceMasterData[] = [];
  private expandCurrent: boolean = false;
  private displayVerticalArr: String[] = [];
  private selectedUploadSkillAttr: string = '';
  private skillDocumentUploaded: string = '';
  private selectedSkills: number[] = [];
  public userFileAttributeDoc: any;
  private startDate: any;
  private replaceSelectedAttributeId: number = -1;
  private selectedSkill: SkillResponse = new SkillResponse();
  private selectedUserAttribute: UserAttribute = new UserAttribute();
  private selectedUserAttrLicenceWrapper: UserLicence = new UserLicence();
  private selectedLicenceIndex;
  private selectedDocumentIndex;
  private documentExpires: boolean = false;
  private skipSkillAttribute: String = '';
  private skipLicenceAttributes: String[] = [];
  private documentExpiresEdit: boolean = true;
  private replaceUploadedDocument: boolean = false;
  private replaceUploadedDocumentEdit: boolean = false;
  private effectiveDateStr: string = '';
  private showModal: boolean = false;
  private showModalEdit: boolean = false;
  private showModalXS: boolean = false;
  private uploadDocument: boolean = false;
  private selectedDocument: DocumentResponse = new DocumentResponse();
  private editMode: boolean = false;
  private editDeleteHeader: string = '';
  private editDeleteBody: string = '';
  private licenceOn: string = '';
  private licenceAuthority: string = '';
  private licenceCountry: string = '';
  private effectiveDate: string = '';
  private effectiveDateDTTM = 0;
  private expiryDateDTTM = 0;
  private expiryDate: string = '';
  private licenceDoc: any = '';
  private displayDocTypes: String = '';
  private supportedFileSize = 0;
  private isDropBoxFileUploaded: boolean = false;
  private dropBoxFile?: string;
  private dropBoxFileName?: string;
  private pageSize: number = 3;

  async mounted() {
    await vxm.licence.getUserLicenceData();
    this.supportedFileSize = vxm.utility.fileUploadMaxSize;
    this.licenceDoc = '';
    this.licenceOn = '';
    this.licenceCountry = '';
    this.licenceAuthority = '';
    this.expiryDate = '';
    this.effectiveDate = '';
    this.licenceUploadInfo = new LicenceUploadInfo();
    this.licenceDocument = new LicenceDocument();
  }

  get licencePager() {
    return vxm.licence.LicencePager;
  }

  async onFetchList(pageNumber) {
    await vxm.licence.getUserLicenceData({
      pageNumber,
      pageSize: this.pageSize,
    });
  }

  async deleteLicenceDocument(
    documentId: number,
    licenceIndex: number,
    index: number,
  ) {
    console.log('DocumentId to be deleted', documentId);
    const vm = this;
    const respPromise: any = vxm.licence.deleteLicenceDocument(documentId);
    const resp = await respPromise;
    if (resp.meta.success) {
      await vxm.licence.getUserLicenceData();
    } else {
      vm.$wlToastr('error', resp.errorMessage, vm.$t('License_LicenceText'));
    }
  }

  get userLicenceList() {
    return vxm.licence.UserLicenceList;
  }

  async deleteLicenceDocumentFromModal(
    documentId: number,
    licenceIndex: number,
    index: number,
  ) {
    console.log('DocumentId to be deleted', documentId);
    const vm = this;
    const respPromise: any = vxm.licence.deleteLicenceDocument(documentId);
    const resp = await respPromise;
    if (resp.meta.success) {
      await vxm.licence.getUserLicenceData();
      this.uploadDocument = false;
    } else {
      vm.$wlToastr('error', resp.errorMessage, vm.$t('License_LicenceText'));
    }
  }

  async saveLicenceDetailsMain() {
    const vm = this;
    this.licenceUploadInfo.licenceMasterId = this.selectedUserAttrLicenceWrapper.licenceMasterId;
    this.licenceUploadInfo.licenceName = this.selectedUserAttrLicenceWrapper.userLicenceName;
    this.licenceUploadInfo.licenceCountry = this.licenceCountry;
    this.licenceUploadInfo.licenceOn = this.licenceOn;
    this.licenceUploadInfo.licenceAuthority = this.licenceAuthority;
    this.licenceUploadInfo.licenceId = this.selectedUserAttrLicenceWrapper.licenceId;

    this.saveLicencePayload.licenceInfo = this.licenceUploadInfo;

    let respPromise: any;
    console.log('uploading file');
    respPromise = vxm.licence.uploadLicenceDocument(this.saveLicencePayload);
    this.uploadDocument = false;
    const resp = await respPromise;
    console.log('Upload response is : ', resp);
    if (resp.meta.success) {
      vm.$wlToastr(
        'success',
        vm.$t('License_DocumentUploadedSuccessfully'),
        vm.$t('License_LicenceText'),
      );
      await vxm.licence.getUserLicenceData({
        pageSize: this.pageSize,
        pageNumber: this.licencePager.resultPage,
      });
    } else {
      vm.$wlToastr('error', resp.errorMessage, vm.$t('License_LicenceText'));
    }
  }

  get aircraftTypes() {
    return vxm.configs.getGlobalConfigValue('AIRFRAMES');
  }

  get allowedResumeFormatText() {
    return vxm.configs.getGlobalConfigValue('ALLOWED_RESUME_FORMATS');
  }

  get countryList() {
    return vxm.passport.CountryList;
  }

  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat;
  }

  get licenceAuthorityList() {
    return vxm.configs.getGlobalConfigValue('LICENCE_AUTHORITY');
  }

  get userLicence(): UserLicence[] {
    if (this.userLicenceList === null) {
      return [];
    }
    return this.userLicenceList;
  }

  cancelSaveLicenceMain() {
    this.replaceUploadedDocument = false;
    //this.showModal = false;
    this.uploadDocument = false;
    this.isDropBoxFileUploaded = false;
    this.dropBoxFile = '';
    this.dropBoxFileName = '';
  }

  checkUserAttrDoc(file: any) {
    setTimeout(() => {
      console.log(this.licenceDoc);
    }, 500);
  }

  editUserAttrDocument(
    val: UserLicence,
    doc: DocumentResponse,
    licenceIndex: number,
    docIndex: number,
  ) {
    console.log('UserLicence Value is', val);
    console.log('Document value is', doc);
    this.selectedUserAttrLicenceWrapper = val;
    this.selectedLicenceIndex = licenceIndex;
    this.selectedDocumentIndex = docIndex;
    this.licenceOn = val.licenceOn;
    this.licenceAuthority = val.licenceAuthority;
    if (val.licenceCountry) {
      this.licenceCountry = val.licenceCountry;
    }
    this.licenceUploadInfo = new LicenceUploadInfo();
    this.licenceDocument = new LicenceDocument();
    this.selectedDocument = doc;
    this.licenceDocument.documentId = doc.documentId;
    this.editMode = true;
    if ('effectiveDate' in doc && doc.effectiveDate !== null) {
      this.effectiveDateDTTM = new Date(doc.effectiveDate).getTime();
      this.effectiveDate = this.$moment(doc.effectiveDate).format('YYYY-MM-DD');
    }
    if ('expiryDate' in doc && doc.expiryDate !== null) {
      this.expiryDateDTTM = new Date(doc.expiryDate).getTime();
      this.expiryDate = this.$moment(doc.expiryDate).format('YYYY-MM-DD');
    }

    if (doc.effectiveDate != null && doc.expiryDate == null) {
      this.documentExpires = true;
    }
    this.uploadDocument = true;
  }

  isDateInPast(dttm: number): boolean {
    if (dttm === null) return false;
    var result = new Date(dttm);
    result.setDate(result.getDate() + 1);
    dttm = result.getTime();
    var expDate = new Date(dttm);
    var now = new Date();
    if (now > expDate) return true;
    else return false;
  }

  isNotNull(val: any) {
    if (val == null || val === null || val == 'null') return false;
    else return true;
  }

  isDocumentUploadedForLicence(val: UserLicence): boolean {
    if (val.licenceCountry && val.licenceAuthority && val.licenceOn) {
      return true;
    } else {
      return false;
    }
  }

  licenceDocTypeMatches(): boolean {
    const ext = this.licenceDoc.name.match(/\.([^\.]+)$/)[1];
    console.log('Extension is : ', ext);
    const allowedResumeFormat = vxm.configs.getGlobalConfigValue(
      'ALLOWED_RESUME_FORMATS',
    );
    console.log('ext::' + ext);
    console.log('allowedResumeFormat::' + allowedResumeFormat);
    return allowedResumeFormat.includes(ext.toLowerCase());
  }

  async downloadResume(fileGUID, name) {
    try {
      const authToken = vxm.users.getToken;
      const url = '/wl-profile-svc/api/v2/user-profile/view/resume/' + fileGUID;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`, 
        },
      });
      
      if (!response.ok) {
        throw new Error('Failed to download resume');
      }
      
      const blob = await response.blob();
      
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = name || 'Resume';
      
      // Trigger a click event to initiate the download
      link.click();
      
      // Clean up the URL object after download
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error downloading resume:', error);
    }
  }

  async previewDocument(docGUID) {
  try {
    const authToken = vxm.users.getToken;
    const url = '/wl-profile-svc/api/v2/user-profile/view/resume/' + docGUID;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${authToken}`, 
      },
    });
    
    if (!response.ok) {
      throw new Error('Failed to preview document');
    }
    
    // Open the document in a new tab
    window.open(response.url, '_blank');
  } catch (error) {
    console.error('Error previewing document:', error);
  }
}

  replaceUploadedDoc() {
    this.replaceUploadedDocument = !this.replaceUploadedDocument;
  }

  selectUserAttrLicenceWrapper(val: UserLicence) {
    console.log('recieved ', val);
    this.selectedUserAttrLicenceWrapper = val;
    this.licenceDocument = new LicenceDocument();
    this.showModal = true;
    this.uploadDocument = true;
    this.editMode = false;
    this.documentExpires = false;
    if (val.licenceCountry) {
      this.licenceCountry = val.licenceCountry;
    }
    this.licenceAuthority = val.licenceAuthority;
    this.licenceOn = val.licenceOn;
    this.expiryDate = '';
    this.effectiveDate = '';
  }

  public transformDate(dttm: number): string {
    console.log('dttm recieved', dttm);
    if (typeof dttm === 'undefined' || dttm === null) return '';
    const locale = vxm.users.getUserLang || 'en';
    return moment(dttm).locale(locale).format(this.getCompanyDateFormat.toUpperCase());
  }
}
